import {getRequestEncrypt} from "./request-encrypt";

/**
 * 预处理axios的config对象
 * @author  韦胜健
 * @date    2019/10/22 19:18
 * @param   axiosConfig         object      Axios请求配置
 * @param   processUrl          boolean     是否进行网关适配，调整url请求前缀
 * @param   ctxPath             string      前端部署路径，appCtx.ctxPath
 * @param   injectLinkRequestId boolean     是否在请求参数中注入linkRequestId，linkRequestId是一个uuid字符串
 * @param   injectEncryptHeader boolean     是否在请求头中写入请求体加密校验字符串
 * @param   cryptoSecret        string      crypto加密密钥，配置文件中的:VUE_APP_cryptoSecret
 * @return  void
 */
function processAxiosConfig(axiosConfig, {processUrl, ctxPath, injectLinkRequestId, injectEncryptHeader, cryptoSecret} = {}) {

    if (!axiosConfig) {
        throw new Error('axiosConfig 不能为空！')
    }

    const {url, method, data, params, headers} = axiosConfig

    /*默认调整url进行网关适配*/
    if (processUrl !== false) {
        axiosConfig.url = processAxiosConfig.processUrl(url, ctxPath)
    }

    /*默认在参数中注入LinkRequestId*/
    if (injectLinkRequestId !== false) {
        processAxiosConfig.injectLinkRequestId(data, params, method)
    }

    /*默认在请求头中注入请求体校验加密字符串*/
    if (injectEncryptHeader !== false) {
        headers['EncryptData'] = processAxiosConfig.injectEncryptHeader(url, method, data, params, cryptoSecret, headers['Content-Type'])
    }

}

processAxiosConfig.getRequestEncrypt = getRequestEncrypt

/**
 * 后端节点分离，网关适配修改
 * @author  韦胜健
 * @date    2019/10/22 19:30
 * @param   url                 string      请求地址
 * @param   ctxPath             string      前端部署路径，appCtx.ctxPath
 * @return  string                          格式化之后的url字符串
 */
processAxiosConfig.processUrl = (url, ctxPath) => {
    url = url.replace(ctxPath, '');
    if (url.startsWith('/link/')) {
        url = '/action' + url;
    } else if (url.startsWith('link/')) {
        url = '/action/' + url;
    } else if (url.startsWith('/loyalty/')) {
        url = '/loyalty' + url;
    } else if (url.startsWith('loyalty/')) {
        url = '/loyalty/' + url;
    }
    return url
}

const LINK_REQUEST_ID = 'linkRequestId'
/**
 * 向参数中注入LinkRequestId属性，如果请求参数不是对象，而是数组之类的，则不做处理
 * @author  韦胜健
 * @date    2019/10/22 19:52
 * @param   data                object|array    请求体参数
 * @param   params              object|array    url参数
 * @param   method              string          请求方法，get以及post，不等于get视为post请求
 * @return  boolean                             是否注入了LinkRequestId
 */
processAxiosConfig.injectLinkRequestId = (data, params, method) => {

    let ret = false
    let body = method.toLowerCase() === 'get' ? params : data

    if (!body) body = {}

    if (body instanceof FormData) {
        if (!body.has(LINK_REQUEST_ID)) {
            body.append(LINK_REQUEST_ID, LinkUtils.uuid())
            ret = true
        } else {
            const lrid = body.get(LINK_REQUEST_ID)
            if (lrid == null || lrid === '') body.delete(LINK_REQUEST_ID)
        }
    } else if (LinkUtils.typeOf(body) === 'object') {
        if (!body.hasOwnProperty(LINK_REQUEST_ID)) {
            body[LINK_REQUEST_ID] = LinkUtils.uuid()
            ret = true
        } else {
            const lrid = body[LINK_REQUEST_ID]
            if (lrid == null || lrid === '') delete body[LINK_REQUEST_ID]
        }
    }

    return ret
}

/**
 * 向请求头中写入请求校验加密字符串
 * @author  韦胜健
 * @date    2019/10/22 19:56
 * @param   url                 string          请求参数
 * @param   method              string          请求方法，get以及post，不等于get视为post请求
 * @param   data                object|array    请求体参数
 * @param   params              object|array    url参数
 * @param   cryptoSecret        string          crypto加密密钥，配置文件中的:VUE_APP_cryptoSecret
 * @param   contentType         string          请求体格式，application/json开头或者application/application/x-www-form-urlencoded
 * @return  string                              加密得到的秘钥
 */
processAxiosConfig.injectEncryptHeader = (url, method, data, params, cryptoSecret, contentType) => {
    let isUploadFile = (contentType || '').indexOf('multipart/form-data')>-1;
    if(!isUploadFile && data instanceof  FormData){
        isUploadFile = true;
    }
    return getRequestEncrypt({
        url,
        method,
        body: method.toLowerCase() === 'get' ? params : data,
        cryptoSecret,
        contentType,
        isUploadFile
    })
}

export {processAxiosConfig}
